import * as React from 'react';
import { StyleSheet, TouchableOpacity, View, ViewStyle } from 'react-native';
import color from '../../style/color';

const TRACK_WIDTH = 51;
const TRACK_HEIGHT = 31;
const THUMB_SIZE = 27;
const THUMB_MARGIN = (TRACK_HEIGHT - THUMB_SIZE) / 2;

type ToggleProps = {
    value: boolean;
    onValueChange: (value: boolean) => void;
    style?: ViewStyle;
};

export default function Toggle({ value, onValueChange, style }: ToggleProps) {
    return (
        <TouchableOpacity
            onPress={() => onValueChange(!value)}
            activeOpacity={0.8}
            style={[styles.track, value ? styles.trackOn : styles.trackOff, style]}>
            <View style={[styles.thumb, value ? styles.thumbOn : styles.thumbOff]} />
        </TouchableOpacity>
    );
}

const styles = StyleSheet.create({
    track: {
        width: TRACK_WIDTH,
        height: TRACK_HEIGHT,
        borderRadius: TRACK_HEIGHT / 2,
        justifyContent: 'center',
        transitionProperty: 'background-color',
        transitionDuration: '200ms',
    } as any,
    trackOn: {
        backgroundColor: color.positiveGreen,
    },
    trackOff: {
        backgroundColor: '#C8C8C8',
    },
    thumb: {
        width: THUMB_SIZE,
        height: THUMB_SIZE,
        borderRadius: THUMB_SIZE / 2,
        backgroundColor: color.white,
        shadowColor: color.black,
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.2,
        shadowRadius: 2,
        transitionProperty: 'transform',
        transitionDuration: '200ms',
    } as any,
    thumbOff: {
        transform: [{ translateX: THUMB_MARGIN }],
    },
    thumbOn: {
        transform: [{ translateX: TRACK_WIDTH - THUMB_SIZE - THUMB_MARGIN }],
    },
});
